import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { DatePipe } from "@angular/common";
import { saveAs } from "file-saver";
import { Loggerservice } from "../../../services/logger-service";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-fare-product",
  templateUrl: "./fare-product.component.html",
  styleUrls: ["./fare-product.component.css"],
  providers: [DatePipe]
})
export class FareProductComponent implements OnInit {
  fpid;
  rejected;
  priviousData: any = [];
  notSelectJC = true;
  newDate: any = new Date();
  disabledown = true;
  endDateInvalid: boolean = false;
  startValueFlag = false;
  endValueFlag = false;
  minRemark = false;
  minPValueNotNumeric: boolean = false;
  notValidMinPercentage: boolean = false;
  maxPValueNotNumeric: boolean = false;
  notValidMaxPercentage: boolean = false;
  tmfValueNotNumeric: boolean = false;
  tmPValueNotNumeric: boolean = false;
  notValidTMPercentage: boolean = false;
  pomrPValueNotNumeric: boolean = false;
  notValidpomrPercentage: boolean = false;

  searchlist: boolean = true;
  searchresult: boolean = false;
  showList: boolean = false;
  thresholdMiles: boolean = false;
  thresholdMilesPercentage: boolean = false;
  journeyName;
  loader: any = false;
  isApproved = false;
  aprvbtn = false;
  approveStatus;
  updateApprove = false;

  viewTitle: string = "Fare Product Master";
  insertDataTitle: string = "Fare Product Master";
  screentitle: string = "Fare Product Master";

  JournyClasses: any = ["Economy Class", "Business Class"];
  economyFareProductLabels: any = [
    { key: "ECOFP1", value: "Economy" },
    { key: "ECOFP2", value: "Economy Plus" },
    { key: "ECOFP3", value: "Economy Pro" }
  ];
  bussinesFareProductLabels: any = [{ key: "BUSFP1", value: "Premium" }];
  fareProductLabels: any = [];
  roundUpValues = [10, 100];
  // countOne = 0;
  // countTwo = 0;
  // countThree = 0;
  actionmode: string = "Seacrh";
  parent_table = "cnf_fare_product";
  previous_Max_RANGE_PERCENTAGE: number;

  JOURNEY_ID = "JOURNEY_ID";
  FARE_PRODUCT_LABEL = "FARE_PRODUCT_LABEL";
  DESCRIPTION = "DESCRIPTION";
  MIN_RANGE_PERCENTAGE = "MIN_RANGE_PERCENTAGE";
  MAX_RANGE_PERCENTAGE = "MAX_RANGE_PERCENTAGE";
  THRESHOLD = "THRESHOLD";
  FIXED_OR_PERCENTAGE = "FIXED_OR_PERCENTAGE";
  THRESHOLD_MILES = "THRESHOLD_MILES";
  THRESHOLD_MILES_PERCENTAGE = "THRESHOLD_MILES_PERCENTAGE";
  APPLICABLE_FROM = "APPLICABLE_FROM";
  APPLICABLE_TO = "APPLICABLE_TO";
  PERCENTAGE_OF_MAX_RANGE = "PERCENTAGE_OF_MAX_RANGE";
  ROUNDUP = "ROUNDUP";

  JOURNEY_NAME = "JOURNEY_NAME";
  childtables = ["UB_MST_JOURNEY_CLASS"];
  filters = ["JOURNEY_ID"];
  parent_table_ID = "FARE_PRODUCT_ID";
  Parent_result_ID = "";

  screenDetails: any = [];
  search_details: any = [];
  p: number = 1;
  searchitem = " ";
  searchColumn = " ";
  serachtabledata: any = [];
  serachTableInfo: any = [];
  data: any = [];
  status: any = {};
  combo_details1: any = [];
  combo_details2: any = [];

  dbFields = [
    this.FARE_PRODUCT_LABEL,
    this.DESCRIPTION,
    this.MIN_RANGE_PERCENTAGE,
    this.MAX_RANGE_PERCENTAGE,
    this.THRESHOLD,
    this.FIXED_OR_PERCENTAGE,
    this.APPLICABLE_FROM,
    this.APPLICABLE_TO,
    this.PERCENTAGE_OF_MAX_RANGE,
    this.ROUNDUP,
    this.JOURNEY_ID
  ];
  dbFieldss = [
    "FARE_PRODUCT_ID",
    this.FARE_PRODUCT_LABEL,
    this.DESCRIPTION,
    this.MIN_RANGE_PERCENTAGE,
    this.MAX_RANGE_PERCENTAGE,
    this.THRESHOLD,
    this.FIXED_OR_PERCENTAGE,
    this.APPLICABLE_FROM,
    this.APPLICABLE_TO,
    this.PERCENTAGE_OF_MAX_RANGE,
    this.ROUNDUP,
    this.JOURNEY_ID,
    "STATUS"
  ];

  sortType = "";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  constructor(
    private vernostService: VernostServiceService,
    private datePipe: DatePipe,
    private logService: Loggerservice,
    private commonService : CommonService
  ) {}

  ngOnInit() {
    //this.logService.create_log("yesssssss", "info");
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    // alert(localStorage.getItem("fname") + " " + localStorage.getItem("lname"));
    // alert("fid"+this.fid);
    console.log(this.fid);

    var rollArray = {
      funId: this.fid,
      roleID: this.roleID
    };
    this.vernostService.checkFunAccess(rollArray).subscribe(response => {
      console.log(JSON.stringify(response[0].addinfo));
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screenDetails = {
      FARE_PRODUCT_LABEL: "",
      DESCRIPTION: "",
      MIN_RANGE_PERCENTAGE: "",
      MAX_RANGE_PERCENTAGE: "",
      THRESHOLD_MILES: "",
      THRESHOLD_MILES_PERCENTAGE: "",
      THRESHOLD: "",
      FIXED_OR_PERCENTAGE: "",
      APPLICABLE_FROM: "",
      APPLICABLE_TO: "",
      PERCENTAGE_OF_MAX_RANGE: "",
      ROUNDUP: "",
      JOURNEY_ID: ""
    };
    this.addCombo(this.childtables[0]);

    this.search_details = {
      JOURNEY_NAME: "",
      FARE_PRODUCT_LABEL: ""
    };
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };
    this.showList = false;
  }

  addForm() {
    this.disabledown = true;
    this.rejected = 0;
    document.getElementById("errs").innerHTML = "";
    this.thresholdMiles = false;
    this.thresholdMilesPercentage = false;
    this.minPValueNotNumeric = false;
    this.notValidMinPercentage = false;
    this.notValidTMPercentage = false;
    this.pomrPValueNotNumeric = false;
    this.notValidpomrPercentage = false;
    this.tmfValueNotNumeric = false;
    this.maxPValueNotNumeric = false;
    this.screenDetails = {
      FARE_PRODUCT_LABEL: "",
      DESCRIPTION: "",
      MIN_RANGE_PERCENTAGE: "",
      MAX_RANGE_PERCENTAGE: "",
      THRESHOLD_MILES: "",
      THRESHOLD_MILES_PERCENTAGE: "",
      APPLICABLE_FROM: "",
      APPLICABLE_TO: "",
      PERCENTAGE_OF_MAX_RANGE: "",
      ROUNDUP: "",
      JOURNEY_ID: ""
    };
    this.notValidMaxPercentage = false;
    this.tmPValueNotNumeric = false;
    this.endDateInvalid = false;
    this.actionmode = "Add";
    this.showList = false;
    this.Parent_result_ID = "";
    this.aprove_details = {
      APPROVAL_REMARKS: ""
    };
  }

  downloadFile() {
    var fname = "out.csv";
    this.vernostService.downloadFile(fname).subscribe(
      data => {
        console.log(JSON.stringify(fname));
        saveAs(data, fname);
      },
      err => {}
    );
  }
  searchForm() {
    this.rejected = 0;
    this.disabledown = true;
    this.updateApprove = false;
    if (this.actionmode != "Edit") {
      this.searchData();
    } else {
      this.search_details.JOURNEY_NAME = "";
      this.search_details.FARE_PRODUCT_LABEL = "";
      this.searchresult = false;
    }

    document.getElementById("errs").innerHTML = "";
    this.thresholdMiles = false;
    this.thresholdMilesPercentage = false;
    this.screenDetails = {
      FARE_PRODUCT_LABEL: "",
      DESCRIPTION: "",
      MIN_RANGE_PERCENTAGE: "",
      MAX_RANGE_PERCENTAGE: "",
      THRESHOLD_MILES: "",
      THRESHOLD_MILES_PERCENTAGE: "",
      APPLICABLE_FROM: "",
      APPLICABLE_TO: "",
      PERCENTAGE_OF_MAX_RANGE: "",
      ROUNDUP: "",
      JOURNEY_ID: ""
    };
    this.minPValueNotNumeric = false;
    this.notValidMinPercentage = false;
    this.maxPValueNotNumeric = false;
    this.notValidMaxPercentage = false;
    this.tmPValueNotNumeric = false;
    this.notValidTMPercentage = false;
    this.pomrPValueNotNumeric = false;
    this.notValidpomrPercentage = false;
    this.tmfValueNotNumeric = false;
    this.endDateInvalid = false;
    this.actionmode = "Search";
    this.aprovebtn = true;
    this.rejectbtn = true;
    this.fareProductLabels = [];
    this.notSelectJC = true;
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    let arrayFareProduct = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayFareProduct).subscribe(res => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      let status = JSON.stringify(res[0].addinfo[0].APPROVAL_STATUS);
      let stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  /*
  sortByOrder(data, numberfare) {
    if (numberfare == 1) {
      if (this.countOne % 2 == 0) {
        this.sortType = "ASC";
      } 
      else {
        this.sortType = "DESC";
      }
      this.countOne++;
      this.countTwo = 0;
      this.countThree = 0;
    }
    if (numberfare == 2) {
      if (this.countTwo % 2 == 0) {
        this.sortType = "ASC";
      } 
      else {
        this.sortType = "DESC";
      }
      this.countTwo++;
      this.countOne = 0;
      this.countThree = 0;
    }
    if (numberfare == 3) {
      if (this.countThree % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.countThree++;
      this.countOne = 0;
      this.countTwo = 0;
    }
    var arrayFareProduct = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayFareProduct).subscribe(res => {
      this.serachtabledata = res;
    });
  } */

/*
*Above code can be refactored as following one. -- Gaurav
*Please change all occurences of sortByOrder function in app after approval 
*
*count = 0;
*prevColumn = 1;
*
*sortByOrder(data, column){
*
*	if(this.prevColumn !== column){
*		this.count = 0;
*	}
*
*	this.sortType =  this.count % 2 === 0 ?  "ASC" :  "DESC";
*
*	this.count = this.count === 0 ? 1 : 0;
*
*	var arrayFareProduct = {
*		sortField: data,
*		parent_table: this.parent_table,
*		childtables: this.childtables,
*		filters: this.filters,
*		sortType: this.sortType,
*		dbFields: this.searchColumn,
*		searchData: this.searchitem
*	};
*	this.vernostService.sortByOrder(arrayFareProduct).subscribe(res => {
*		this.serachtabledata = res;
*	});
*
*} */

  addCombo(childtable) {
    let arrayFareProduct = {
      childtable: childtable
    };
    this.vernostService.getComboData(arrayFareProduct).subscribe(res => {
      if (res[0].status == this.childtables[0]) {
        this.combo_details1 = res[0].result;
      }
      if (res[0].status == this.childtables[1]) {
        this.combo_details2 = res[0].result;
      }
    });
  }

  changeName() {
    // alert(this.Parent_result_ID);
    var data = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "FARE_PRODUCT_ID"
    };

    this.vernostService.getSTATUS(data).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    document.getElementById("errs").innerHTML = "";
    if (this.actionmode == "Edit") {
      let dataFareProduct = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(dataFareProduct).subscribe(res => {
        this.isApproved = false;
      });
    }
  }

  /**
   * No Reference Found for this code. Pls re-check before deleting - Gaurav
   */

  /* changeBtnColor(id, status) {
    if (status == 0) {
      status = 1;
    } else if (status == 1) {
      status = 0;
    }

    let dataFareProduct = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "FARE_PRODUCT_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataFareProduct).subscribe(res => {
      this.searchData();
    });
  } */

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'fare-product');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();
    var dbFieldFareProduct = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataFareProduct = [
      status,
      this.aprove_details.APPROVAL_REMARKS,
      this.uid,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldFareProduct,
      parent_table: this.parent_table,
      formData: formDataFareProduct,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    console.log("aaart=" + JSON.stringify(array));
    this.vernostService.aproveReject(array).subscribe(response => {
      this.aprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        // this.searchForm();

        this.logService.create_log(
          "'Action':Rejected,'Modified by':" +
            localStorage.getItem("fname") +
            "'Record':" +
            JSON.stringify(this.screenDetails),
          "info"
        );
        this.rejected = 2;

        // this.searchData();
        //  document.getElementById("errs").innerHTML = response[0].message;
      } else {
        //  document.getElementById("errs").innerHTML = response[0].message;
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }

        if (response[0].aproval == "aproved") {
          this.aprvbtn = false;

          this.logService.create_log(
            "'Action':Approved,'Modified by':" +
              localStorage.getItem("fname") +
              "'Record':" +
              JSON.stringify(this.screenDetails),
            "info"
          );
          // this.aprovebtn=false;
          //  alert(JSON.stringify(response[0].status));
          //  this.searchForm();
        }
        this.aprvbtn = false;
        /* if (response[0].aproval == "rejected") {
          this.aprvbtn = false;
          // this.aprovebtn=false;
          //  alert(JSON.stringify(response[0].status));
          //this.searchForm();
        } else {
          this.aprvbtn = false;
          // alert("in else");
          // this.rejectbtn=false;
          // alert(JSON.stringify(response[0].status));
          // this.searchForm();
        } */
      }
      if (this.actionmode == "Edit") {
        console.log("@@@@@@@@@");
        this.submitdata();
      }
      this.searchData();
    });
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        this.isApproved = true;
      }
    }
    this.Parent_result_ID = formData;
  
    var arrayFareProduct = {
      parent_table: this.parent_table,
      dbFields: this.dbFieldss,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
  
    this.vernostService.getData(arrayFareProduct).subscribe(res => {
      this.fpid = res[0].result[0].FARE_PRODUCT_ID;
      this.screenDetails = {
        FARE_PRODUCT_LABEL: res[0].result[0].FARE_PRODUCT_LABEL,
        DESCRIPTION: res[0].result[0].DESCRIPTION,
        MIN_RANGE_PERCENTAGE: res[0].result[0].MIN_RANGE_PERCENTAGE,
        MAX_RANGE_PERCENTAGE: res[0].result[0].MAX_RANGE_PERCENTAGE,
        APPLICABLE_FROM: res[0].result[0].APPLICABLE_FROM,
        APPLICABLE_TO: res[0].result[0].APPLICABLE_TO,
        PERCENTAGE_OF_MAX_RANGE: res[0].result[0].PERCENTAGE_OF_MAX_RANGE,
        ROUNDUP: res[0].result[0].ROUNDUP,
        JOURNEY_ID: res[0].result[0].JOURNEY_ID
      };
  
      this.getFareProduct(this.screenDetails.JOURNEY_ID);
      this.approveStatus = res[0].result[0].STATUS;
      var FIXED_OR_PERCENTAGE = res[0].result[0].FIXED_OR_PERCENTAGE;
      var THRESHOLD = res[0].result[0].THRESHOLD;
      if (FIXED_OR_PERCENTAGE == 1) {
        this.screenDetails.THRESHOLD_MILES = THRESHOLD;
      } else {
        this.screenDetails.THRESHOLD_MILES_PERCENTAGE = THRESHOLD;
      }
  
      this.serachTableInfo = res[0].result;
      var parent_table = "cnf_fare_product";
      var childtables = ["UB_MST_JOURNEY_CLASS"];
      var datalike = ["JOURNEY_ID"];
      var dbFields = ["JOURNEY_NAME"];
      let data;
      var findData = [this.screenDetails.JOURNEY_ID];
      if (toggle == "1") {
        data = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };
  
        this.vernostService.searchRecordById(data).subscribe(searchResponse => {
          var f1 = searchResponse[0];
          this.journeyName = f1[0].JOURNEY_NAME;
        });
        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        data = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };
        this.vernostService.searchRecordById(data).subscribe(searchRecordResponse => {
          var f1 = searchRecordResponse[0];
          this.journeyName = f1[0].JOURNEY_NAME;
        });
        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  isDisabled = false;

  toggleDisabling(): void {
    this.isDisabled = !this.isDisabled;
  }

  checkPriceEnd() {
    this.gotochangestatus();
    this.endValueFlag = false;
    var startValue = (document.getElementById(
      "price_range_start"
    ) as HTMLInputElement).value;
    var endValue = (document.getElementById(
      "price_range_end"
    ) as HTMLInputElement).value;

    var x = parseInt(startValue);
    var y = parseInt(endValue);

    if (x >= y) {
      this.endValueFlag = true;
      document.getElementById("pend").innerHTML =
        "Max Range% should be greater than Min Range%";
    } else {
      this.endValueFlag = false;
      document.getElementById("pend").innerHTML = "";
      this.startValueFlag = false;
      document.getElementById("pstart").innerHTML = "";
    }
    // }
  }

  checkThresholdMiles(data) {
    document.getElementById("errs").innerHTML = "";
    console.log(data);
    if (data != "") {
      this.thresholdMilesPercentage = true;
      this.screenDetails.THRESHOLD_MILES_PERCENTAGE = "";
    } else {
      this.thresholdMilesPercentage = false;
    }

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      //  this.RAC_APROVE = "1";
    }
    this.tmfValueNotNumeric = false;
    if (data == "") {
      this.tmfValueNotNumeric = false;
    } else {
      var regx = /^[0-9]\d*(\.\d+)?$/;
      var checkAlphabet = regx.test(data);

      if (!checkAlphabet) {
        this.tmfValueNotNumeric = true;
      } else {
        this.tmfValueNotNumeric = false;
      }
    }
  }
  checkThresholdMilesPercentage(data) {
    document.getElementById("errs").innerHTML = "";
    console.log(data);
    if (data != "") {
      this.thresholdMiles = true;
      this.screenDetails.THRESHOLD_MILES = "";
    } else {
      this.thresholdMiles = false;
    }

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      // this.RAC_APROVE = "1";
    }

    this.tmPValueNotNumeric = false;
    this.notValidTMPercentage = false;

    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.tmPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      var checkPercentage =true;
      if (checkPercentage == true) {
        this.notValidTMPercentage = false;
      } else {
        this.notValidTMPercentage = true;
      }
    } else {
      this.tmPValueNotNumeric = true;
    }
  }

  checkStartDate(event) {
    this.endDateInvalid = false;
    this.gotochangestatus();
    document.getElementById("errs").innerHTML = "";
    if (this.screenDetails.APPLICABLE_TO != "") {
      this.screenDetails.APPLICABLE_FROM = this.datePipe.transform(
        this.screenDetails.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screenDetails.APPLICABLE_TO = this.datePipe.transform(
        this.screenDetails.APPLICABLE_TO,
        "yyyy-MM-dd"
      );

      if (
        this.screenDetails.APPLICABLE_FROM > this.screenDetails.APPLICABLE_TO
      ) {
        this.endDateInvalid = true;
      } else {
        this.endDateInvalid = false;
      }
    }
  }
  checkEndDate(event) {
    this.gotochangestatus();
    document.getElementById("errs").innerHTML = "";
    if (this.screenDetails.APPLICABLE_FROM != "") {
      this.screenDetails.APPLICABLE_FROM = this.datePipe.transform(
        this.screenDetails.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screenDetails.APPLICABLE_TO = this.datePipe.transform(
        this.screenDetails.APPLICABLE_TO,
        "yyyy-MM-dd"
      );

      if (
        this.screenDetails.APPLICABLE_FROM > this.screenDetails.APPLICABLE_TO
      ) {
        this.endDateInvalid = true;
      } else {
        this.endDateInvalid = false;
      }
    }
  }

  submitdata() {
    if (
      this.screenDetails.THRESHOLD_MILES == "" ||
      this.screenDetails.THRESHOLD_MILES == undefined
    ) {
      this.screenDetails.THRESHOLD = this.screenDetails.THRESHOLD_MILES_PERCENTAGE;
      this.screenDetails.FIXED_OR_PERCENTAGE = 0;
    }
    if (
      this.screenDetails.THRESHOLD_MILES_PERCENTAGE == "" ||
      this.screenDetails.THRESHOLD_MILES_PERCENTAGE == undefined
    ) {
      this.screenDetails.THRESHOLD = this.screenDetails.THRESHOLD_MILES;
      this.screenDetails.FIXED_OR_PERCENTAGE = 1;
    }

    if (
      this.screenDetails.JOURNEY_ID == "" ||
      this.screenDetails.JOURNEY_ID == undefined ||
      this.screenDetails.FARE_PRODUCT_LABEL == "" ||
      this.screenDetails.FARE_PRODUCT_LABEL == undefined ||
      this.screenDetails.DESCRIPTION == "" ||
      this.screenDetails.DESCRIPTION == undefined ||
      // this.screenDetails.MIN_RANGE_PERCENTAGE == "" ||
      // this.screenDetails.MIN_RANGE_PERCENTAGE == undefined
      // this.screenDetails.MAX_RANGE_PERCENTAGE == "" ||
      // this.screenDetails.MAX_RANGE_PERCENTAGE == undefined ||
      this.screenDetails.APPLICABLE_FROM == "" ||
      this.screenDetails.APPLICABLE_FROM == undefined ||
      this.screenDetails.APPLICABLE_TO == "" ||
      this.screenDetails.APPLICABLE_TO == undefined ||
      this.screenDetails.PERCENTAGE_OF_MAX_RANGE == "" ||
      this.screenDetails.PERCENTAGE_OF_MAX_RANGE == undefined ||
      this.screenDetails.ROUNDUP == "" ||
      this.screenDetails.ROUNDUP == undefined ||
      (this.screenDetails.THRESHOLD_MILES == "" &&
        this.screenDetails.THRESHOLD_MILES_PERCENTAGE == "")
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      document.getElementById("errs").innerHTML = "";
      this.screenDetails.APPLICABLE_FROM = this.datePipe.transform(
        this.screenDetails.APPLICABLE_FROM,
        "yyyy-MM-dd"
      );
      this.screenDetails.APPLICABLE_TO = this.datePipe.transform(
        this.screenDetails.APPLICABLE_TO,
        "yyyy-MM-dd"
      );
      var formData = [
        this.screenDetails.FARE_PRODUCT_LABEL,
        this.screenDetails.DESCRIPTION,
        this.screenDetails.MIN_RANGE_PERCENTAGE,
        this.screenDetails.MAX_RANGE_PERCENTAGE,
        this.screenDetails.THRESHOLD,
        this.screenDetails.FIXED_OR_PERCENTAGE,
        this.screenDetails.APPLICABLE_FROM,
        this.screenDetails.APPLICABLE_TO,
        this.screenDetails.PERCENTAGE_OF_MAX_RANGE,
        this.screenDetails.ROUNDUP,
        this.screenDetails.JOURNEY_ID
      ];

      console.log("formData" + formData);

      this.priviousData = this.screenDetails;
      if (this.actionmode != "Edit") {
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          formData: formData,
          USER_ID: this.uid,
          PAGENAME: "FAREPRODUCT"
        };

        console.log("in submit");
        this.vernostService.insertData(Data).subscribe(response => {
          console.log(JSON.stringify(response[0].message));
          if (response[0].message == "Data inserted") {
            console.log(JSON.stringify(response[0].message));
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";
            this.showFormData(response[0].addinfo, 3, 1, 1);
            this.logService.create_log(
              "'Action':Create Record,'Modified by':" +
                localStorage.getItem("fname") +
                ",'Record':" +
                JSON.stringify(this.screenDetails),
              "info"
            );
          }
          if (response[0].message == "Data Not inserted") {
            console.log(JSON.stringify(response[0].message));
            document.getElementById("errs").innerHTML =
              "Fare Product is already present for selected date range";
          }
        });
      }

      if (this.actionmode == "Edit") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editFareProductData(array).subscribe(response => {
          console.log(JSON.stringify(response[0].message));
          if (response[0].message == "Update Fail") {
            document.getElementById("errs").innerHTML =
              "Fare Product is already present for selected date range";
          } else {
            // this.searchForm();
            document.getElementById("errs").innerHTML =
              "Record Updated Successfully";
            this.loader = false;

            this.logService.create_log(
              "'Action':Update Record,'Modified by':" +
                localStorage.getItem("fname") +
                ",'Privious Record':" +
                JSON.stringify(this.priviousData) +
                ",'New Record':" +
                JSON.stringify(this.screenDetails),
              "info"
            );

            // setTimeout(() => {
            //   document.getElementById("errs").innerHTML = "";
            //   document.getElementById("errs").style.background = "#ebccd1";
            //   document.getElementById("errs").style.color = "#a94442";
            // }, 5000);
          }
        });
      }
    }
  }

  getFareProduct(id) {
    if (this.screenDetails.JOURNEY_ID != "") {
      this.notSelectJC = false;
    }

    // id = this.screenDetails.JOURNEY_ID;
    console.log("id" + id);

    if (id == 1) {
      this.fareProductLabels = this.economyFareProductLabels;
      console.log("fareProductLabels" + this.fareProductLabels);
      console.log("label" + this.screenDetails.FARE_PRODUCT_LABEL);
    }
    if (id == 2) {
      this.fareProductLabels = this.bussinesFareProductLabels;
      console.log("fareProductLabels" + this.fareProductLabels);
      console.log("label" + this.screenDetails.FARE_PRODUCT_LABEL);
    }
  }

  searchFPLabels: any = [];
  searchData() {
    this.searchlist = false;
    this.loader = true;
    var field1 = this.search_details.JOURNEY_NAME;
    var field2 = this.search_details.FARE_PRODUCT_LABEL;
    console.log("this.search_details", this.search_details);

    if (field1 == "" && field2 == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "") {
        searchitem.push(field1);
        searchColumn.push("JOURNEY_NAME");
      }
      if (field2 != "") {
        searchitem.push(field2);
        searchColumn.push("FARE_PRODUCT_LABEL");
      }

      console.log(this.parent_table);
      var data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters,
        flag: "1"
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchRecord(data).subscribe(resp => {
        if (resp.length > 0) {
          this.loader = false;
          console.log("resule=" + JSON.stringify(resp));
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = resp;
          this.searchresult = true;
          this.disabledown = false;
          this.logService.create_log(
            "Action:Srarch Record,Modified by:" + localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  checkMinValuePerc(data) {
    this.gotochangestatus();

    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      //  this.RAC_APROVE = "1";
    }

    this.minPValueNotNumeric = false;
    this.notValidMinPercentage = false;

    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      var startValue = (document.getElementById(
        "price_range_start"
      ) as HTMLInputElement).value;
      var endValue = (document.getElementById(
        "price_range_end"
      ) as HTMLInputElement).value;

      this.startValueFlag = false;
      if (endValue != "") {
        var x = parseInt(startValue);
        var y = parseInt(endValue);
        if (x > y) {
          console.log("hii");
          this.startValueFlag = true;
          document.getElementById("pstart").innerHTML =
            "Min Range% should be lesser than Max Range%";
        } else {
          console.log("byy");
          this.startValueFlag = false;
          document.getElementById("pstart").innerHTML = "";
          document.getElementById("pend").innerHTML = "";
        }
      }

      this.minPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      var checkPercentage =true;
      if (checkPercentage == true) {
        this.notValidMinPercentage = false;
      } else {
        this.notValidMinPercentage = true;
        document.getElementById("pstart").innerHTML = "";
      }
    } else {
      this.minPValueNotNumeric = true;
      document.getElementById("pstart").innerHTML = "";
    }
  }

  checkMaxValuePerc(data) {
    console.log(data);
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
    }

    this.maxPValueNotNumeric = false;
    this.notValidMaxPercentage = false;

    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.gotochangestatus();
      this.maxPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      var checkPercentage =true;
      if (checkPercentage == true) {
        this.notValidMaxPercentage = false;
      } else {
        this.notValidMaxPercentage = true;
      }
    } else {
      this.maxPValueNotNumeric = true;
    }
  }

  checkPOMRValuePerc(data) {
    document.getElementById("errs").innerHTML = "";
    console.log(data);
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
    }

    this.pomrPValueNotNumeric = false;
    this.notValidpomrPercentage = false;

    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.pomrPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      var checkPercentage =true;
      if (checkPercentage == true) {
        this.notValidpomrPercentage = false;
      } else {
        this.notValidpomrPercentage = true;
      }
    } else {
      this.pomrPValueNotNumeric = true;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }

  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getName() {
    let name = this.search_details.JOURNEY_NAME;
    if (name == "Economy Class") {
      this.searchFPLabels = this.economyFareProductLabels;
    }

    if (name == "Business Class") {
      this.searchFPLabels = this.bussinesFareProductLabels;
    }
  }
}
